<app-navbar [title]="'Przypomnienie hasła'"></app-navbar>

<div class="alert alert-danger" role="alert" *ngIf="formError">
	{{ formError }}
</div>

<div class="container" *ngIf="!code">
	<form (submit)="onSubmitEmail()" *ngIf="!formDone">
		<div class="mb-3">
			<label for="email">Adres e-mail</label>
			<input type="email" class="form-control" id="email" name="email" [(ngModel)]="email" />
		</div>
		<p>
			<button type="submit" class="btn btn-primary">Wyślij</button>
		</p>
	</form>

	<div class="alert alert-success" role="alert" *ngIf="formDone">
		{{ formDone }}
	</div>
</div>

<div class="container" *ngIf="code">
	<form (submit)="onSubmitPass()" *ngIf="!formDone">
		<div class="mb-3">
			<label for="password">Nowe hasło</label>
			<input type="password" class="form-control" id="password" name="password" [(ngModel)]="password" />
		</div>
		<div class="mb-3">
			<label for="password2">Powtórz nowe hasło</label>
			<input type="password" class="form-control" id="password2" name="password2" [(ngModel)]="password2" />
		</div>
		<p>
			<button type="submit" class="btn btn-primary">Zapisz</button>
		</p>
	</form>

	<div class="alert alert-success" role="alert" *ngIf="formDone">
		<p>
			{{ formDone }}
		</p>
		<p>
			<a routerLink="/logout">Zaloguj się</a>
		</p>
	</div>
</div>
